module.exports = __webpack_public_path__ + "img/@header_bg_group.dc2e485a.jpg";